<template>
  <div class="header_wrap">
    <div id="head_area">
      <div id="head_area_inner" class="clearfix">
        <h1><a :href="`${mypageRootPath}/../index.jsp`"><img :src="`${mypageRootPath}/common/image/logo.png`" alt="MISAWA" width="277" height="31" class="png_bg"></a></h1>
        <p class="name" v-if="!noLogin">
          ようこそ<span>{{ clName }}</span>様
          <template v-if="isMgGroupMember">（社員）</template>
          <template v-if="isReformMember">（ミサワリフォーム）</template>
          <template v-if="isMansionMember">（{{ mansionName }}）</template>
        </p>
        <div class="switch-owner" v-if="!noLogin">
          <span class="building-name">{{ buildingName }}</span>
          <span class="switch-owner-button" v-if="other_owners.length > 0">
            建物･契約切替
            <span class="count">{{ other_owners.length + 1}}</span>
          </span>
        </div>
        <div class="togglebtn menuopen" v-if="!isApp"></div>
      </div>
    </div>
    <div id="menu_area">
      <div class="togglebtn menuclose"></div>
      <h2>CONTENTS</h2>
      <div id="menu01">
        <ul class="clearfix" :data-items-count="6">
          <li>
            <a :href="`${mypageRootPath}/maintenanceinfo`" target="_self" class="need-login">Myページ</a>
          </li>
          <li>
            <a href="https://www.misawa.co.jp/ownersclub/yutai/" target="_self" class="need-login">オーナーさま限定優待</a>
          </li>
          <!-- 「need-login」が有効に動作するように、オーバーレイ非表示時のa要素とオーバーレイ表示時のa要素を用意しておきます。 -->
          <li data-overlay="#menu01_02_overlay">
            <a href="https://life.misawa.co.jp/link.php" target="_self">公式通販らいさぽWeb</a>
            <a href="https://life.misawa.co.jp/link.php" target="_self" class="need-login">公式通販らいさぽWeb</a>
          </li>
          <li data-overlay="#menu01_03_overlay">
            <a :href="`${mypageRootPath}/../maintenance/main/`" target="_self">お手入れ･メンテナンス</a>
            <a :href="`${mypageRootPath}/../maintenance/main/`" target="_self">お手入れ･メンテナンス</a>
          </li>
          <li data-overlay="#menu01_04_overlay">
            <a :href="`${mypageRootPath}/../column/`" target="_self">くらしのコラム</a>
            <a :href="`${mypageRootPath}/../column/`" target="_self" class="need-login">くらしのコラム</a>
          </li>
          <li data-overlay="#menu01_05_overlay">
            <a href="/jsp/ownersclub/reform/" target="_self">リフォームしたい</a>
            <a href="/jsp/ownersclub/reform/" target="_self">リフォームしたい</a>
          </li>
          <li data-overlay="#menu01_06_overlay">
            <a href="https://www.misawa.co.jp/ownersclub/fudosan_support/index.html" target="_self">売りたい･貸したい</a>
            <a href="https://www.misawa.co.jp/ownersclub/fudosan_support/index.html" target="_self">売りたい･貸したい</a>
          </li>
          <li data-overlay="#menu01_07_overlay">
            <a href="https://www.misawa.co.jp/ownersclub/kakusyu/index.html" target="_self">各種ご相談・お問い合わせ</a>
            <a href="https://www.misawa.co.jp/ownersclub/kakusyu/index.html" target="_self">各種ご相談・お問い合わせ</a>
          </li>
        </ul>
      </div>

      <!-- オーバーレイメニュー -->
      <div id="menu01_02_overlay" class="menu-overlay">
        <div class="overlay-cont">
          <a class="close" href=""></a>
          <h3><a href="https://life.misawa.co.jp/link.php" target="_self" class="need-login">公式通販らいさぽWeb</a></h3>
          <ul class="links">
            <li><a href="https://life.misawa.co.jp/link.php" target="_blank" class="need-login">らいさぽWeb</a>
              <li><a href="https://www.misawa.co.jp/ownersclub/yutai/uchinokoto.html" class="need-login">ウチノコトサービス</a>
          </ul>
        </div>
      </div>
      <div id="menu01_03_overlay" class="menu-overlay">
        <div class="overlay-cont">
          <a class="close" href=""></a>
          <h3><a :href="`${mypageRootPath}/../maintenance/main/`" target="_self">お手入れ･メンテナンス</a></h3>
          <ul class="links">
            <li><a :href="`${mypageRootPath}/../maintenance/main/`">部位別お手入れ･メンテナンス</a>
              <li><a :href="`${mypageRootPath}/../maintenance/movie/`">お手入れ動画</a>
                <li v-if="!isMansionMember"><a :href="`${mypageRootPath}/../maintenance/checklist/`">年1回のチェックリスト</a>
                  <li v-if="!isMansionMember"><a :href="`${mypageRootPath}/../maintenance/warranty/`">保証制度・アフターサービス</a>
          </ul>
        </div>
      </div>
      <div id="menu01_04_overlay" class="menu-overlay">
        <div class="overlay-cont">
          <a class="close" href=""></a>
          <h3><a :href="`${mypageRootPath}/../column/`" target="_self" class="need-login">くらしのコラム</a></h3>
          <ul class="links">
            <li><a :href="`${mypageRootPath}/../column/?category=life`" class="need-login">生活</a>
              <li><a :href="`${mypageRootPath}/../column/?category=family`" class="need-login">家族</a>
                <li><a :href="`${mypageRootPath}/../column/?category=health`" class="need-login">健康</a>
                  <li><a :href="`${mypageRootPath}/../column/?category=meal`" class="need-login">食事</a>
          </ul>
        </div>
      </div>
      <div id="menu01_05_overlay" class="menu-overlay">
        <div class="overlay-cont">
          <a class="close" href=""></a>
          <h3><a href="/jsp/ownersclub/reform/" target="_self">リフォームしたい</a></h3>
          <ul class="links">
            <li><a href="/jsp/ownersclub/reform/#jirei">リフォーム事例</a>
              <li><a href="/jsp/ownersclub/reform/#academy">実践リフォーム塾</a>
                <li><a href="/jsp/ownersclub/reform/#recommend">オススメリフォーム</a>
                  <li><a href="https://www.misawa.co.jp/ownersclub/senior/">理想のセカンドライフ</a>
          </ul>
        </div>
      </div>
      <div id="menu01_06_overlay" class="menu-overlay">
        <div class="overlay-cont">
          <a class="close" href=""></a>
          <h3><a href="https://www.misawa.co.jp/ownersclub/fudosan_support/index.html" target="_self">売りたい･貸したい</a></h3>
          <ul class="links">
            <li><a href="https://www.misawa.co.jp/ownersclub/fudosan_support/sell.html#sumstock">適正な評価で自宅を売りたい方</a>
              <li><a href="https://www.misawa.co.jp/ownersclub/fudosan_support/sell.html#homever">早く確実に自宅を売りたい方</a>
                <li><a href="https://www.misawa.co.jp/ownersclub/fudosan_support/rent.html">自宅を手放さず貨したい方</a>
                  <li><a href="https://www.misawa.co.jp/ownersclub/sumikae/">住み替え</a>
          </ul>
        </div>
      </div>
      <div id="menu01_07_overlay" class="menu-overlay">
        <div class="overlay-cont">
          <a class="close" href=""></a>
          <h3><a href="https://www.misawa.co.jp/ownersclub/kakusyu/index.html" target="_self">各種ご相談・お問い合わせ</a></h3>
          <ul class="links">
            <li><a href="https://plt.asp.traina.jp/misawa/traina-faq/">よくあるお問い合わせ</a>
              <li><a href="https://www.misawa.co.jp/ownersclub/introduce/">ご紹介制度について</a>
                <li><a href="https://www.misawa.co.jp/jsp/ownersclub/login/life_support/maintenance/inquiry3.jsp">修理のご依頼・メンテナンスのご相談</a>
                  <li><a href="https://www.misawa.co.jp/jsp/ownersclub/login/life_support/reform/inquiry3.jsp">リフォーム・インテリア・エクステリアのご相談</a>
                    <li><a href="https://www.misawa.co.jp/jsp/ownersclub/login/fudosan_support/otoiawase/inquiry.jsp">不動産のご相談</a>
                      <li><a href="https://www.misawa.co.jp/jsp/ownersclub/login/life_support/apartment_sisan/inquiry3.jsp">アパート・資産活用のご相談</a>
                        <li><a href="https://www.misawa.co.jp/jsp/ownersclub/login/otoiawase/inquiry3.jsp">当サイトに関するお問い合わせ</a>
                          <li><a href="https://www.misawa.co.jp/owner_support/popup/contact_list.html">お電話でのご相談・お問い合わせ</a>
          </ul>
        </div>
      </div>

      <!-- 右上のリンク -->
      <div id="menu02">
        <ul>
          <li><i class="fas fa-chevron-right"></i><a id="menu02_01" href="https://www.misawa.co.jp/otikaku/index.html" target="_blank">お近くのミサワホーム</a>
            <li><i class="fas fa-chevron-right"></i><a id="menu02_02" href="https://www.misawa.co.jp/ownersclub/kakusyu/index.html" target="_self">各種ご相談・お問い合わせ</a>
        </ul>
      </div>

      <!-- 会員用ボタン -->
      <div id="menu03" v-if="!noLogin">
        <ul>
          <li>
            <a :href="changeInfoUrl" @click.prevent="clickChangeInfoUrl">
              <i class="fas fa-chevron-right"></i>
              {{isMgGroupMember ? '社員' : '会員'}}情報の変更
            </a>
          </li>
          <li>
            <a :href="`${mypageRootPath}/../logout.jsp`" target="_self" class="current">
              <i class="fas fa-chevron-right"></i>
              ログアウト
            </a>
          </li>
        </ul>
      </div>
    </div>
    <!-- 建物・契約切替メニュー -->
    <div id="switch-owner-menu" v-if="!noLogin">
      <div class="body">
        <div class="header">
          <div class="h-and-notice">
            <h3>建物・契約切替</h3>
            <span class="notice">会員情報の変更はメインアカウントからのみ可能です</span>
          </div>
          <span class="name">{{ clName }}様</span>
          <a class="close-menu" href="">×</a>
        </div>
        <ul class="owners">
          <li v-for="(owner, index) in [current, other_owners].flat()"
              :key="owner.oid"
              :class="{ current: index == 0, primal: primal_oid == owner.oid }">
            <h3 v-if="index == 1">他の建物・契約</h3>
            <div class="body">
              <div class="index" :data-index="index">{{ index >= 10 ? index : ("0" + index) }}</div>
              <div class="main">
                <div class="home-photo">
                  <a href="" @click.prevent="click_upload_home_photo(owner)">
                    <img :src="'/jsp/ownersclub/my/home_photo.jsp?oid=' + owner.oid" v-if="owner.has_home_photo">
                    <img src="/jsp/ownersclub/my/panels/login/home_photo/image/home_pc.png" v-if="!owner.has_home_photo">
                  </a>
                </div>
                <h4>
                  <span class="building-name">{{ owner.building_name }}</span>
                  <a href="" class="edit-building-name" :data-oid="owner.oid" :data-building-name="owner.building_name">
                    <img src="/jsp/ownersclub/my/common/image/ico_pen.png">
                  </a>
                </h4>
                <dl>
                  <dt>契約No.</dt><dd>{{ owner.contract_number }}</dd>
                  <dt>契約物件番号</dt><dd>{{ owner.contract_building_no }}</dd>
                  <dt>引 渡 日</dt><dd>{{ owner.delvery_date }}</dd>
                  <dt>築 年 数</dt><dd><template v-if="owner.building_years != null">{{ owner.building_years }}年</template></dd>
                  <dt>建 設 地</dt><dd>{{ owner.contract_address }}</dd>
                </dl>
              </div>
              <div class="primal-and-switch">
                <span class="primal" v-if="primal_oid == owner.oid">メインアカウント</span>
                <form action="/jsp/ownersclub/switch_owner.jsp" method="post" v-if="index > 0">
                  <input type="hidden" name="oid" :value="owner.oid">
                  <button class="switch">切 替</button>
                </form>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <!-- 建物名編集ダイアログ -->
    <div id="building-name-editor">
      <div class="body">
        <h1>建物名変更</h1>
        <form action="/jsp/ownersclub/my/update_building_name.jsp" method="post">
          <input type="hidden" name="oid">
          <dl>
            <dt>建物名</dt>
            <dd><input type="text" name="building_name"></dd>
          </dl>
          <div class="buttons">
            <button class="submit">変更</button>
            <button type="button" class="cancel">キャンセル</button>
          </div>
        </form>
      </div>
    </div>
    <!-- 建物・契約切替メニュー -->
    <div id="is-pc"></div>
  </div>
</template>

<script>
import Common from './Common.js'

export default {
  name: 'moc-header',
  mixins: [ Common ],
  computed: {
    changeInfoImageSrc () {
      const filename = this.isMgGroupMember ? 'menu03_04.gif' : 'menu03_01.gif'
      return `${this.mypageRootPath}/common/image/menu/${filename}`
    }
  },
  methods: {
    click_upload_home_photo (owner) {
      window.open("/jsp/ownersclub/my/upload_home_photo.jsp?oid=" + owner.oid,
        "upload_home_photo",
        "width=560,height=400,scrollbars=yes");
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/MocHeader.vue